/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgMsgNotice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 16 16"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={16} height={16} fill="#EDA500" rx={8} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.243 9.2H4.725a.727.727 0 0 1-.634-.366c-.052-.088-.201-.399.053-.776.09-.154.212-.349.353-.565a5.975 5.975 0 0 0 .652-1.332c.072-.218.108-.453.108-.696a2.68 2.68 0 0 1 .556-1.66 2.57 2.57 0 0 1 .575-.54c.18-.121.365-.218.552-.291.806-.358 2.145-.065 2.127.01.184.072.35.157.502.258.228.15.43.338.6.559a2.72 2.72 0 0 1 .542 1.655c0 .236.036.468.109.693a5.316 5.316 0 0 0 .657 1.333c.134.197.255.366.364.507a.699.699 0 0 1 .158.477.768.768 0 0 1-.399.624.743.743 0 0 1-.357.11Zm-1.215 1.787.782-.782 1.826 1.825-.783.783-1.825-1.826Zm-2.581-.368h1.106v2.58H7.447v-2.58Zm-1.475.368-.782-.782-1.826 1.825.783.783 1.825-1.826Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgMsgNotice)
export default Memo
